import { Roe } from '@app/models/payroll/roe.model';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { TranslatableKey } from '@app/types/translatable.type';

export class RoeDownloadPdfColumn extends Column {
    title = '';
    property = null;
    sortable = false;
    type = CellDisplay.actionLink;

    getButtonText(): TranslatableKey {
        return 'payroll.roes.downloadPdf';
    }

    getEvent(): string {
        return 'downloadPdf';
    }

    showIf(roe: Roe): boolean {
        return roe.validationErrors.length === 0;
    }
}
